module.exports = __webpack_public_path__ + "static/media/2_2.c39df627.png";